import CryptoJS from 'crypto-js';
import Resizer from 'react-image-file-resizer';
import {uploadImageMaxWidth} from './const';

const StorageSecretKey = {
  secretKey: 'lgbeta',
};

export const putEncStorage = (key, value) => {
  const encrypted = CryptoJS.AES.encrypt(value, StorageSecretKey.secretKey);
  sessionStorage.setItem(key, encrypted);
};

export const getDecStorage = (key) => {
  const encrypted = sessionStorage.getItem(key);
  if (encrypted === undefined || encrypted === null) {
    return '';
  }
  const decrypted = CryptoJS.AES.decrypt(encrypted, StorageSecretKey.secretKey);
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const encToken = (key) => {
  const encrypted = sessionStorage.getItem(key);
  if (encrypted === undefined || encrypted === null) {
    return '';
  }
  return encrypted.toString(CryptoJS.enc.Utf8);
};

/**
 * 에디터 이미지 업로드 시 이미지 사이즈 가져오기
 * @param file
 * @returns {Promise<unknown>}
 */
export const getFileSize = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    let imgWidth = 0;
    let imgHeight = 0;
    reader.readAsDataURL(file);
    reader.onload = function () {
      let img = new Image();
      img.src = reader.result;
      img.onload = function () {
        imgWidth = img.width;
        imgHeight = img.height;
        resolve({width: imgWidth, height: imgHeight});
      };
    };
  });
};

// image resize
export const resizeFile = async (file, maxWidth = null) => {
  const imgSize = await getFileSize(file);
  const maxImageSize = maxWidth === null ? uploadImageMaxWidth : maxWidth;
  let imgWidthSize = imgSize.width;
  if (Number(imgSize.width) > Number(maxImageSize)) imgWidthSize = maxImageSize;
  return new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      Number(imgWidthSize),
      'auto',
      'jpeg',
      75,
      0,
      (uri) => {
        resolve(uri);
      },
      'base64',
    );
  });
};

/**
 * 서버 타입별 정의
 * LOCAL, QA, KIC(한국), AIC(북미), EIC(유럽)
 * @type {{QA: string, KIC: string, LOCAL: string, AIC: string, EIC: string}}
 */
const serverType = {
  LOCAL: 'local',
  QA: 'qa',
  KIC: 'KIC',
  AIC: 'AIC',
  EIC: 'EIC',
};

/**
 * 공통부 설정값
 * show_thirdparty_login="소셜 로그인 지정(AMZ,FBK,GGL,NAV)"
 * @type {{qa: {continent: string, redirectUrl: string, clientId: string, loginUrl: string, domain: string, countryCd: string, userUrl: string}, KIC: {continent: string, redirectUrl: string, clientId: string, loginUrl: string, domain: string, countryCd: string, userUrl: string}, AIC: {continent: string, redirectUrl: string, clientId: string, loginUrl: string, domain: string, countryCd: string, userUrl: string}, local: {continent: string, redirectUrl: string, clientId: string, loginUrl: string, domain: string, countryCd: string, userUrl: string}, EIC: {continent: string, redirectUrl: string, clientId: string, loginUrl: string, domain: string, countryCd: string, userUrl: string}}}
 */
const commonOptions = {
  local: {
    domain: 'http://127.0.0.1:8080/api/v1/',
    // domain: "https://121.0.0.1:8080/api/v1/",
    redirectUrl: 'http%3a%2f%2fqt2-kic-betaprogram-lge-com.aws-sdp.net%2flogin',
    clientId: '2ca0449ab0234f27b8f6f7b900401336',
    countryCd: 'KR',
    // loginUrl: `https://qt-[[[countryCd]]].m.lgaccount.com/login/sign_in?authSvr=oauth2&callbackUrl=https://qt2-kic.betaprogram.lge.com&svc_list=SVC417&division=EXT:TVBETA&country=[[[countryCd]]]&language=[[[language]]]&expire_session=Y&cross_login=N&except_new=N&terms_name=&third_party_service_name=&show_3rd_party_login=Y&response_type=code&client_id=2ca0449ab0234f27b8f6f7b900401336&state=aa123&redirect_uri=http%3a%2f%2fqt2-kic-betaprogram-lge-com.aws-sdp.net%2flogin`,
    loginUrl:
      'https://[[[countryCd]]].lgemembers.com/lgacc/service/v1/signin?callback_url=http%3a%2f%2flocalhost%3a3000%2flogin%3fclient_id=2ca0449ab0234f27b8f6f7b900401336&country=[[[countryCd]]]&language=[[[language]]]&svc_code=SVC417&webview_y=N',
    logoutUrl: 'https://[[[countryCd]]].lgemembers.com/lgacc/service/v1/signout?svc_code=SVC417&redirect_url=http%3a%2f%2flocalhost%3a3000%2flogin',
    // 'https://qt-[[[countryCd]]].lgaccount.com/logout/sign_out?authSvr=emp&callbackUrl=https://qt2-kic.betaprogram.lge.com&country=[[[countryCd]]]&division=EXT:TVBETA&language=[[[language]]]',
    webOsUrl: `https://qt-[[[countryCd]]].m.lgaccount.com/join/terms/?callbackUrl=https://qt2-kic.betaprogram.lge.com&country=[[[countryCd]]]&expire_session=Y&language=[[[language]]]&show_thirdparty_login=AMZ,FBK,GGL,NAV&svcCode=SVC417`,
    // joinUrl: `https://qt-[[[countryCd]]].m.lgaccount.com/join/terms/?callbackUrl=https://qt2-kic.betaprogram.lge.com&country=[[[countryCd]]]&expire_session=Y&language=[[[language]]]&show_thirdparty_login=AMZ,FBK,GGL,NAV&svcCode=SVC417`,
    joinUrl:
      'https://[[[countryCd]]].lgemembers.com/lgacc/service/v1/signup/selfAuth?callbackUrl=http%3A%2F%2Flocalhost%3a3000&country=[[[countryCd]]]&language=[[[language]]]&svc_code=SVC417&occup_yn=N&occup_must_yn=N&redirect_uri=http%3a%2f%2flocalhost%3a3000%2flogin',
    privacyPolicyUrl: `https://qt-[[[countryCd]]].m.lgaccount.com/customer/terms_detail?country=[[[countryCd]]]&language=[[[language]]]&terms_svcCode=SVC417&terms_type=[[[policyType]]]`,
    termsConditionsUrl: `https://qt-[[[countryCd]]].m.lgaccount.com/customer/terms_detail?country=[[[countryCd]]]&language=[[[language]]]&terms_svcCode=SVC417&terms_type=[[[termsType]]]`,
    continent: 'kr',
  },

  qa: {
    domain: 'https://qt2-kic.betaprogram.lge.com/api/v1/',
    redirectUrl: 'http%3a%2f%2fqt2-kic-betaprogram-lge-com.aws-sdp.net%2flogin',
    clientId: '2ca0449ab0234f27b8f6f7b900401336',
    countryCd: 'KR',
    webOsUrl: `https://qt-[[[countryCd]]].m.lgaccount.com/join/terms/?callbackUrl=https://qt2-kic.betaprogra.lge.com&country=[[[countryCd]]]&expire_session=Y&language=[[[language]]]&show_thirdparty_login=N&svcCode=SVC417`,
    loginUrl:
      'https://qa-kr.account.lge.com/lgacc/service/v1/signin?callback_url=https%3a%2f%2fqt2-kic.betaprogram.lge.com%2flogin%3fclient_id=2ca0449ab0234f27b8f6f7b900401336&country=[[[countryCd]]]&language=[[[language]]]&svc_code=SVC417&webview_y=N',
    logoutUrl: 'https://qa-kr.account.lge.com/lgacc/service/v1/signout?svc_code=SVC417&redirect_url=http%3a%2f%2fqt2-kic-betaprogram-lge-com.aws-sdp.net%2flogin',
    joinUrl:
      'https://qa-kr.account.lge.com/lgacc/service/v1/signup/selfAuth?callbackUrl=https%3A%2F%2Fqt2-kic.betaprogram.lge.com&country=[[[countryCd]]]&language=[[[language]]]&svc_code=SVC417&occup_yn=N&occup_must_yn=N&redirect_uri=http%3a%2f%2fqt2-kic-betaprogram-lge-com.aws-sdp.net%2flogin',
    privacyPolicyUrl: `https://qt-[[[countryCd]]].m.lgaccount.com/customer/terms_detail?country=[[[countryCd]]]&language=[[[language]]]&terms_svcCode=SVC417&terms_type=[[[policyType]]]`,
    termsConditionsUrl: `https://qt-[[[countryCd]]].m.lgaccount.com/customer/terms_detail?country=[[[countryCd]]]&language=[[[language]]]&terms_svcCode=SVC417&terms_type=[[[termsType]]]`,
    continent: 'kr',
  },
  KIC: {
    domain: 'https://betaprogram.lge.com/api/v1/',
    redirectUrl: 'https%3a%2f%2fbetaprogram.lge.com%2flogin',
    clientId: '4c888eb40af84c369bfdd2000a275aff',
    countryCd: 'KR',
    loginUrl: `https://[[[countryCd]]].lgemembers.com/lgacc/service/v1/signin?callback_url=https%3a%2f%2fbetaprogram.lge.com%2flogin%3fclient_id=4c888eb40af84c369bfdd2000a275aff&country=[[[countryCd]]]&language=[[[language]]]&svc_code=SVC417&webview_y=N`,
    // loginUrl: `https://[[[countryCd]]].m.lgaccount.com/login/sign_in?authSvr|response_type=oauth2&callbackUrl|redirect_uri=https://betaprogram.lge.com&svc_list=SVC417&division=EXT:TVBETA&country=[[[countryCd]]]&language=[[[language]]]&expire_session=Y&cross_login=N&show_3rd_party_login=AMZ,FBK,GGL,NAV&client_id=4c888eb40af84c369bfdd2000a275aff&state=aa123`,
    logoutUrl: 'https://[[[countryCd]]].lgaccount.com/logout/sign_out?authSvr=emp&callbackUrl=https://betaprogram.lge.com&country=[[[countryCd]]]&division=EXT:TVBETA&language=[[[language]]]',
    webOsUrl: `https://[[[countryCd]]].m.lgaccount.com/join/terms/?callbackUrl=https://betaprogram.lge.com&country=[[[countryCd]]]&expire_session=Y&language=[[[language]]]&show_3rd_party_login=N&svcCode=SVC417`,
    joinUrl: `https://[[[countryCd]]].m.lgaccount.com/join/terms/?callbackUrl=https://betaprogram.lge.com&country=[[[countryCd]]]&expire_session=Y&language=[[[language]]]&show_3rd_party_login=N&svcCode=SVC417`,
    privacyPolicyUrl: `https://[[[countryCd]]].m.lgaccount.com/customer/terms_detail?country=[[[countryCd]]]&language=[[[language]]]&terms_svcCode=SVC417&terms_type=[[[policyType]]]`,
    termsConditionsUrl: `https://[[[countryCd]]].m.lgaccount.com/customer/terms_detail?country=[[[countryCd]]]&language=[[[language]]]&terms_svcCode=SVC417&terms_type=[[[termsType]]]`,
    continent: 'kr',
  },
  AIC: {
    domain: 'https://us.betaprogram.lge.com/api/v1/',
    redirectUrl: 'https%3a%2f%2fus.betaprogram.lge.com%2flogin',
    clientId: '4c888eb40af84c369bfdd2000a275aff',
    countryCd: 'US',
    loginUrl: `https://[[[countryCd]]].lgemembers.com/lgacc/service/v1/signin?callback_url=https%3a%2f%2fus.betaprogram.lge.com%2flogin%3fclient_id=4c888eb40af84c369bfdd2000a275aff&country=[[[countryCd]]]&language=[[[language]]]&svc_code=SVC417&webview_y=N`,
    // loginUrl: `https://[[[countryCd]]].m.lgaccount.com/login/sign_in?authSvr|response_type=oauth2&callbackUrl|redirect_uri=https://us.betaprogram.lge.com&svc_list=SVC417&division=EXT:TVBETA&country=[[[countryCd]]]&language=[[[language]]]&expire_session=Y&cross_login=N&show_3rd_party_login=AMZ,FBK,GGL&client_id=4c888eb40af84c369bfdd2000a275aff&state=aa123`,
    logoutUrl: 'https://[[[countryCd]]].lgaccount.com/logout/sign_out?authSvr=emp&callbackUrl=https://us.betaprogram.lge.com&country=[[[countryCd]]]&division=EXT:TVBETA&language=[[[language]]]',
    webOsUrl: `https://[[[countryCd]]].m.lgaccount.com/join/terms/?callbackUrl=https://us.betaprogram.lge.com&country=[[[countryCd]]]&expire_session=Y&language=[[[language]]]&show_3rd_party_login=Y&svcCode=SVC417`,
    joinUrl: `https://[[[countryCd]]].m.lgaccount.com/join/terms/?callbackUrl=https://us.betaprogram.lge.com&country=[[[countryCd]]]&expire_session=Y&language=[[[language]]]&show_3rd_party_login=Y&svcCode=SVC417`,
    privacyPolicyUrl: `https://[[[countryCd]]].m.lgaccount.com/customer/terms_detail?country=[[[countryCd]]]&language=[[[language]]]&terms_svcCode=SVC417&terms_type=[[[policyType]]]`,
    termsConditionsUrl: `https://[[[countryCd]]].m.lgaccount.com/customer/terms_detail?country=[[[countryCd]]]&language=[[[language]]]&terms_svcCode=SVC417&terms_type=[[[termsType]]]`,
    continent: 'us',
  },
  EIC: {
    domain: 'https://eu.betaprogram.lge.com/api/v1/',
    redirectUrl: 'https%3a%2f%2feu.betaprogram.lge.com%2flogin',
    clientId: '4c888eb40af84c369bfdd2000a275aff',
    countryCd: 'EU',
    loginUrl: `https://[[[countryCd]]].lgemembers.com/lgacc/service/v1/signin?callback_url=https%3a%2f%2feu.betaprogram.lge.com%2flogin%3fclient_id=4c888eb40af84c369bfdd2000a275aff&country=[[[countryCd]]]&language=[[[language]]]&svc_code=SVC417&webview_y=N`,
    // loginUrl: `https://[[[countryCd]]].lgaccount.com/login/sign_in?authSvr=oauth2&callbackUrl=https://eu.betaprogram.lge.com&svc_list=SVC417&division=EXT:TVBETA&country=[[[countryCd]]]&language=[[[language]]]&expire_session=Y&cross_login=N&except_new=N&terms_name=&third_party_service_name=&show_3rd_party_login=AMZ,FBK,GGL&response_type=code&client_id=4c888eb40af84c369bfdd2000a275aff&state=aa123&redirect_uri=https%3a%2f%2feu.betaprogram.lge.com%2flogin`,
    logoutUrl: 'https://[[[countryCd]]].lgaccount.com/logout/sign_out?authSvr=emp&callbackUrl=https://eu.betaprogram.lge.com&country=[[[countryCd]]]&division=EXT:TVBETA&language=[[[language]]]',
    webOsUrl: `https://[[[countryCd]]].m.lgaccount.com/join/terms/?callbackUrl=https://eu.betaprogram.lge.com&country=[[[countryCd]]]&expire_session=Y&language=[[[language]]]&show_3rd_party_login=Y&svcCode=SVC417`,
    joinUrl: `https://[[[countryCd]]].m.lgaccount.com/join/terms/?callbackUrl=https://eu.betaprogram.lge.com&country=[[[countryCd]]]&expire_session=Y&language=[[[language]]]&show_3rd_party_login=Y&svcCode=SVC417`,
    privacyPolicyUrl: `https://[[[countryCd]]].m.lgaccount.com/customer/terms_detail?country=[[[countryCd]]]&language=[[[language]]]&terms_svcCode=SVC417&terms_type=[[[policyType]]]`,
    termsConditionsUrl: `https://[[[countryCd]]].m.lgaccount.com/customer/terms_detail?country=[[[countryCd]]]&language=[[[language]]]&terms_svcCode=SVC417&terms_type=[[[termsType]]]`,
    continent: 'eu',
  },
};

/**
 * 서버 타입 정의
 * LOCAL, QA, KIC(한국), AIC(북미), EIC(유럽)
 * Build 파일 생성 시, winBuild로 생성
 */
export const common = commonOptions[serverType.EIC];
